import { useQuery } from "@tanstack/react-query";

import { mutateData } from "@/core/api/api-methods";
import type { ListRequest, Paged } from "@/core/api/pagination";
import { QUERY_KEYS } from "@/core/api/query-keys";
import { walletEndpoints } from "@/features/wallet/api/endpoints";
import type { WalletDto, WalletFilter } from "@/features/wallet/api/dto";

/**
 * Liste paginée des portefeuilles (`POST /Wallets/all` — les listes sont en
 * POST, guide §4.2). Lecture authentifiée : `mutateData` en queryFn, la
 * requête reste une query TanStack (cache, invalidation).
 */
export const useWallets = (
  params: ListRequest<WalletFilter> = {},
  enabled = true
) =>
  useQuery({
    queryKey: QUERY_KEYS.WALLET_LIST(params),
    queryFn: () =>
      mutateData({
        url: walletEndpoints.wallets.all,
        reqBody: params as unknown as Record<string, unknown>,
        method: "POST",
      }) as Promise<Paged<WalletDto>>,
    enabled,
  });
